





























import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'

settings =
  name: 'BrandOpportunityShow'
  components: { SuperContainerView, Back }
  vue:
    props: ['brandOpportunityId']
  resources:
    item:
      resourceName: 'brandOpportunity'
      slug: 'brand_opportunities/:brandOpportunityId'

export default VueOptions.vue settings
